/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_SignInResponse_ } from '../models/BaseDataResponse_SignInResponse_';
import type { BaseDataResponse_InitRegisterResponse_ } from '../models/BaseDataResponse_InitRegisterResponse_';
import type { BaseDataResponse_CompleteRegistrationResponse_ } from '../models/BaseDataResponse_CompleteRegistrationResponse_';
import type { SignInRequest } from '../models/SignInRequest';
import type { RegisterRequest } from '../models/RegisterRequest';
import type { CompleteRegistrationRequest } from '../models/CompleteRegistrationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Sign In
     * @param requestBody
     * @returns BaseDataResponse_SignInResponse_ Successful Response
     * @throws ApiError
     */
    public static signInApiAuthSignInPost(
        requestBody: SignInRequest,
    ): CancelablePromise<BaseDataResponse_SignInResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/sign-in',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: credentials_not_verified`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Init Registration Endpoint
     * @param requestBody
     * @returns BaseDataResponse_InitRegisterResponse_ Successful Response
     * @throws ApiError
     */
    public static initRegistrationEndpointApiAuthRegisterPost(
        requestBody: RegisterRequest,
    ): CancelablePromise<BaseDataResponse_InitRegisterResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Code: user_already_exists`,
                429: `Code: registration_rate_limited`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Complete Registration Endpoint
     * @param requestBody
     * @returns BaseDataResponse_CompleteRegistrationResponse_ Successful Response
     * @throws ApiError
     */
    public static completeRegistrationEndpointApiAuthRegisterCompletePost(
        requestBody: CompleteRegistrationRequest,
    ): CancelablePromise<BaseDataResponse_CompleteRegistrationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/register/complete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: registration_token_not_found or Code: invalid_verification_code`,
                409: `Code: user_already_exists`,
                429: `Code: registration_rate_limited`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
